import Row from 'react-bootstrap/Row';
import React from "react";
import Button from "react-bootstrap/Button";
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import SoftSilicone from '../../images/SoftSiliconeCase.png';
import Card2 from '../../images/card2.png';
import Card3 from '../../images/card3.png';
import Card4 from '../../images/card4.png';
import Card5 from '../../images/card5.png';
import Card6 from '../../images/card6.png';
function UsePoints() {
    return (
        <div>
            <div style={{
                marginBottom: '30px',
                marginTop: '30px'
            }}>


                <span style={{
                    fontFamily: 'Sintony',
                    color: '#475666',
                    fontSize: '14px',
                    fontWeight: '700',
                    marginBottom: '30px'

                }}
                >POPULAR REWARDS</span>
            </div>

            <div style={{
                paddingLeft: '25px'
            }}>
                <Row>
                    <Col>
                        <Card style={{ width: '145px' }}>
                            <Card.Img variant="top" src={SoftSilicone} />
                            <Card.Body>

                                <Card.Text>
                                    Soft Silicone Case for IQOS
                                </Card.Text>
                                <Button variant="success" style={{
                                    fontSize: '12px',
                                    backgroundColor: '#00A78A',
                                    width: '100px',
                                    height: '43px',
                                    fontFamily: 'Sintony',
                                    borderRadius: '0',
                                }}>REDEEM</Button>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{ width: '145px' }}>
                            <Card.Img variant="top" src={Card2} />
                            <Card.Body>

                                <Card.Text>
                                    IQOS 2.4 and 2.4+ Cap
                                </Card.Text>
                                <Button variant="success" style={{
                                    fontSize: '12px',
                                    backgroundColor: '#00A78A',
                                    width: '100px',
                                    height: '43px',
                                    fontFamily: 'Sintony',
                                    borderRadius: '0',
                                }}>REDEEM</Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row style={{
                    marginTop: '30px'
                }}>
                    <Col>
                        <Card style={{ width: '145px' }}>
                            <Card.Img variant="top" src={Card3} />
                            <Card.Body>

                                <Card.Text>
                                    Leather Case
                                    for IQOS
                                </Card.Text>
                                <Button variant="success" style={{
                                    fontSize: '12px',
                                    backgroundColor: '#00A78A',
                                    width: '100px',
                                    height: '43px',
                                    fontFamily: 'Sintony',
                                    borderRadius: '0',
                                }}>REDEEM</Button>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{ width: '145px' }}>
                            <Card.Img variant="top" src={Card4} />
                            <Card.Body>

                                <Card.Text>
                                    Soft Silicone Case for IQOS
                                </Card.Text>
                                <Button variant="success" style={{
                                    fontSize: '12px',
                                    backgroundColor: '#00A78A',
                                    width: '100px',
                                    height: '43px',
                                    fontFamily: 'Sintony',
                                    borderRadius: '0',
                                }}>REDEEM</Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row style={{
                    marginTop: '30px'
                }}>
                    <Col>
                        <Card style={{ width: '145px' }}>
                            <Card.Img variant="top" src={Card5} />
                            <Card.Body>

                                <Card.Text>
                                    Blue Silicone Case
                                    for IQOS
                                </Card.Text>
                                <Button variant="success" style={{
                                    fontSize: '12px',
                                    backgroundColor: '#00A78A',
                                    width: '100px',
                                    height: '43px',
                                    fontFamily: 'Sintony',
                                    borderRadius: '0',
                                }}>REDEEM</Button>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{ width: '145px' }}>
                            <Card.Img variant="top" src={Card6} />
                            <Card.Body>

                                <Card.Text>
                                    Soft Silicone Case for IQOS
                                </Card.Text>
                                <Button variant="success" style={{
                                    fontSize: '12px',
                                    backgroundColor: '#00A78A',
                                    width: '100px',
                                    height: '43px',
                                    fontFamily: 'Sintony',
                                    borderRadius: '0',
                                }}>REDEEM</Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            <div style={{
                marginTop: '20px',
                marginBottom: '30px'
            }}>
                <Button variant="outline-secondary" size="lg" type="submit" style={{
                    height: '43px',
                    width: '123px',
                    fontSize: '12px',
                    borderRadius: '0',
                    color: '#575757',
                    borderColor: '#575757'

                }} >
                    SHOW MORE
                </Button>
            </div>
        </div>
    );
}

export default UsePoints;